// extracted by mini-css-extract-plugin
module.exports = {"root":"CbDigitalAgreementSettings_root__3H0CU"};